import axios from 'axios'
import gsap from 'gsap'

export default {
	name: "AppNews",
	props: {
		numberpost: {
			type: Number
		},
		allnewslength: {
			type: Number
		},
		news: {
			type: Array
		}
	},
	data() {
		return {
			newsOffset: 0,
			newsArray: null,
			newsArrayMore: null,
			readMore: null,
			newsMoreBoxIndex: Number,
			indexNews: Number,
			newsMoreBoxDesktop: null,
			newsBoxOverlayDesktop: null,
			newsIndexSet: new Set(),
			moreBoxIndexSet: new Set(),
			flag: true,
			tlEnter: null,
			tlLeave: null
		}
	},
	mounted() {
		this.newsArray = this.news;
		this.newsBoxes = document.querySelector('.news__boxes');
		this.checkCountNews();
		this.observeAnimation();

		window.addEventListener('resize', this.handleResize);
		document.addEventListener('keydown', this.pressKey);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		document.addEventListener('keydown', this.pressKey);
	},
	methods: {
		pressKey(e) {
			let mqlA = window.matchMedia("(max-width: 420px)")

			if (!mqlA.matches && e.keyCode == 27) {
				this.closeMoreNews();
			}
		},
		observeAnimation() {
			const teamContent = document.querySelector('.news');

			let optionsEnter = {
				rootMargin: "0px",
				threshold: 0.25
			}

			this.leaveAnim();

			let observerEnter = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio > 0.25 && enter.boundingClientRect.top > 0) {
						this.enterAnim()
					}
				})
			}, optionsEnter);

			observerEnter.observe(teamContent);

			let optionsLeave = {
				rootMargin: "0px",
				threshold: 0
			}

			let observerLeave = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio == 0 && enter.boundingClientRect.top > 0) {
						this.leaveAnim()
					}
				})
			}, optionsLeave);

			observerLeave.observe(teamContent);
		},
		enterAnim() {
			this.tlEnter = gsap.timeline()

			if (this.tlLeave && this.tlLeave.isActive()) {
				this.tlLeave.kill();
			}

			this.tlEnter
				.to(this.newsBoxes.children, { y: 0, opacity: 1, stagger: 0.1 })
		},
		leaveAnim() {
			this.tlLeave = gsap.timeline()

			if (this.tlEnter && this.tlEnter.isActive()) {
				this.tlEnter.kill();
			}

			this.tlLeave
				.to(this.newsBoxes.children, { y: 100, opacity: 0 })
		},
		mobileAnimation() {
			const newsMoreBox = this.containerNews.querySelector('.more_read')
			const newsMoreBoxHeight = newsMoreBox.offsetHeight;
			const newsMoreBoxClose = this.containerNews.querySelector('.news__boxes__box__content__close')
			const newsMoreBoxRead = this.containerNews.querySelector('.news__boxes__box__content__read_more')
			gsap.timeline()
				.to(newsMoreBox, {
					duration: 0.4, position: 'relative', opacity: 1, visibility: 'visible', maxHeight: newsMoreBoxHeight, onComplete: () => {
						gsap.set(newsMoreBox, { clearProps: 'maxHeight' })
					}
				})
				.to(newsMoreBoxRead, { duration: 0.4, autoAlpha: 0 }, '-=0.4')
				.set(newsMoreBoxRead, { display: 'none' })
				.set(newsMoreBoxClose, { display: 'block' })
				.to(newsMoreBoxClose, { duration: 0.4, autoAlpha: 1 }, '+=0.1')

			newsMoreBoxClose.addEventListener('click', this.closeMoreNewsMobile)
		},
		arrowScrollToSection() {
			gsap.to(window, { scrollTo: this.newsMoreBoxDesktop, duration: 0.4 })
		},
		addArrowListener() {
			this.newsBoxOverlayDesktop.addEventListener('click', this.arrowScrollToSection);
		},
		removeArrowListener() {
			this.newsBoxOverlayDesktop.removeEventListener('click', this.arrowScrollToSection);
		},
		desktopAnimation() {
			this.newsBoxOverlayDesktop = document.querySelector(`div[data-news="${this.newsMoreBoxIndex}"] .news__boxes__box__overlay`);
			this.removeArrowListener();
			this.addArrowListener();
			gsap.set(this.newsMoreBoxDesktop, { clearProps: 'display' })
			const newsMoreBoxHeight = this.newsMoreBoxDesktop.offsetHeight;

			gsap.timeline()
				.to(window, { scrollTo: this.newsMoreBoxDesktop, ease: "power2.out" })
				.fromTo(this.newsMoreBoxDesktop, { position: 'relative', maxHeight: 0, y: -50, marginBottom: 0 }, { duration: 0.4, y: 0, marginBottom: 60, maxHeight: newsMoreBoxHeight, opacity: 1 }, '-=0.3')
				.to(this.newsBoxOverlayDesktop, { duration: 0.4, top: 0, opacity: 1, visibility: 'visible' }, '-=0.4')

			document.querySelector(`[data-row="${this.indexNews}"] .news__boxes__box__more_text__close`).addEventListener('click', this.closeMoreNews);

		},
		desktopAnimationContent() {
			const newsMoreBoxRead = document.querySelectorAll('.news__boxes__box__content__read_more')

			gsap.timeline({
				onComplete: () => {
					this.nextNewsAnimation()
				}
			})
				.set(newsMoreBoxRead, { clearProps: 'opacity,visibility,display' })
				.to(this.newsMoreBoxDesktop, { duration: 0.4, maxHeight: 0, marginBottom: 0, y: -50 })
				.set(this.newsBoxOverlayDesktop.children[0], { clearProps: 'transform' })
				.to(this.newsBoxOverlayDesktop, { duration: 0.4, top: "-100%", opacity: 0 }, '-=0.4')
				.set(this.newsBoxOverlayDesktop, { visibility: 'hidden' })
				.set(this.newsMoreBoxDesktop, { position: 'absolute', clearProps: 'maxHeight,display', opacity: 0 })
		},
		nextNewsAnimation() {
			this.checkMoreBoxPosition();
			this.newsMoreBoxDesktop.children[1].children[0].textContent = this.newsArray[this.newsMoreBoxIndex].post_date_custom
			this.newsMoreBoxDesktop.children[1].children[1].textContent = this.newsArray[this.newsMoreBoxIndex].post_title
			this.newsMoreBoxDesktop.children[1].children[2].innerHTML = this.newsArray[this.newsMoreBoxIndex].post_content
			this.checkIsFile();

			let newsMoreCurrentContainerHeight = this.newsMoreBoxDesktop.offsetHeight;
			this.newsBoxOverlayDesktop = document.querySelector(`div[data-news="${this.newsMoreBoxIndex}"] .news__boxes__box__overlay`);
			this.removeArrowListener();
			this.addArrowListener();

			gsap.timeline()
				.to(this.newsBoxOverlayDesktop, { duration: 0.4, top: 0, opacity: 1, visibility: 'visible' })
				.to(this.newsMoreBoxDesktop, { duration: 0.4, position: 'relative', maxHeight: newsMoreCurrentContainerHeight, marginBottom: 60, opacity: 1, y: 0 }, '-=0.4')
				.to(window, { scrollTo: this.newsMoreBoxDesktop, ease: "power2.out" }, '-=0.35')
		},
		checkIsFile() {
			const files = document.querySelectorAll('.news__boxes__box__more_text__content__files__file');
			const filesContainer = document.querySelector('.news__boxes__box__more_text__content__files');

			if (files) {
				files.forEach(el => el.remove())
			}

			if (this.newsArray[this.newsMoreBoxIndex].post_files.length > 0) {
				filesContainer.classList.remove('var_disable');

				this.newsArray[this.newsMoreBoxIndex].post_files.forEach(el => {
					var fileHtml = `<div class="news__boxes__box__more_text__content__files__file">
						<a href="${el.file_path}" download></a>
						<img src="/wp-content/themes/averton/dist/assets/download_asset.svg" />
						<p>${el.name}</p>
						<p>${(el.filesize / 1000).toFixed(0)}kB</p>
					</div>`

					filesContainer.insertAdjacentHTML('beforeend', fileHtml)
				})
			} else {
				filesContainer.classList.add('var_disable');
			}
		},
		createNewsMoreBoxDesktop() {
			if (this.newsMoreBoxDesktop && this.newsMoreBoxDesktop.getAttribute('data-row') == this.indexNews) return;

			const html = `<span data-row="${this.indexNews}" data-more="${this.newsMoreBoxIndex}" class="news__boxes__box__more_text">
			<div class="news__boxes__box__more_text__close">
				<span></span>
				<span></span>
			</div>
			<div class="news__boxes__box__more_text__content">
				<p class="news__boxes__box__more_text__content__date">${this.newsArray[this.newsMoreBoxIndex].post_date_custom}</p>
				<h2>${this.newsArray[this.newsMoreBoxIndex].post_title}</h2>
				<div class="news__boxes__box__more_text__content__wysiwyg">
					${this.newsArray[this.newsMoreBoxIndex].post_content}
				</div>
				<div class="news__boxes__box__more_text__content__files"></div>
			</div>
		</span>`


			document.querySelector(`div[data-news="${this.indexNews}"]`).insertAdjacentHTML('afterend', html);
			this.newsMoreBoxDesktop = document.querySelector(`[data-more="${this.newsMoreBoxIndex}"]`);
			this.checkIsFile();
		},
		readMoreNews(index) {
			this.newsMoreBoxIndex = index;
			this.containerNews = document.querySelector(`div[data-news="${this.newsMoreBoxIndex}"]`);
			this.lastNewsIndex();
			if (this.flag) {
				this.createNewsMoreBoxDesktop();
				this.desktopAnimation();
				this.flag = false;
			} else {
				this.desktopAnimationContent();
			}
			this.mobileAnimation();
			this.checkOddNewsTablet();

			this.newsIndexSet.add(this.indexNews);
			this.moreBoxIndexSet.add(this.newsMoreBoxIndex);
		},
		checkOddNewsTablet() {
			const tablet = window.matchMedia('(max-width: 1200px)');

			if (tablet.matches) {
				const modulo = this.newsArray.length % 2;

				if (modulo) {
					if (this.newsMoreBoxIndex == this.newsArray.length - 1) {
						let newDiv = document.createElement("div");
						newDiv.className = 'fake';
						this.containerNews.after(newDiv);
					}
				}
			}
		},
		checkMoreBoxPosition() {
			this.lastNewsIndex();
			const moreNewsBoxes = document.querySelector('.news__boxes__box__more_text');

			const cloneElement = moreNewsBoxes.cloneNode(true)
			moreNewsBoxes.remove();
			cloneElement.setAttribute('data-row', `${this.indexNews}`)
			this.newsMoreBoxDesktop = cloneElement;

			document.querySelector(`div[data-news="${this.indexNews}"]`).after(cloneElement);
			document.querySelector(`[data-row="${this.indexNews}"] .news__boxes__box__more_text__close`).addEventListener('click', this.closeMoreNews);
		},
		closeMoreNews() {
			this.removeArrowListener();

			this.moreBoxIndexSet.forEach(el => {
				const container = document.querySelector(`div[data-news="${el}"]`)
				const read_more = container.querySelector('.news__boxes__box__content__read_more')
				read_more.removeAttribute('style');
			})

			if (document.querySelector('.fake')) {
				document.querySelector('.fake').remove();
			}

			const scrollTo = document.querySelector(`div[data-news="${this.indexNews}"]`);

			gsap.timeline({
				onComplete: () => {
					gsap.set(this.newsMoreBoxDesktop, { display: 'none', clearProps: 'maxHeight' })
				}
			})
				.fromTo(this.newsMoreBoxDesktop, { maxHeight: this.newsMoreBoxDesktop.offsetHeight }, { duration: 0.4, maxHeight: 0, opacity: 0, marginBottom: 0, y: -50 })
				.to(this.newsBoxOverlayDesktop.children[0], { duration: 0.2, rotate: 270 }, '-=0.4')
				.to(this.newsBoxOverlayDesktop, { duration: 0.2, top: '-100%', opacity: 0, visibility: 'hidden' }, '-=0.2')
				.to(window, { scrollTo: scrollTo, ease: "power2.easeIn" }, '-=0.5')
		},
		closeMoreNewsMobile(e) {
			const indexOfParent = e.target.parentElement.parentElement.getAttribute('data-news');
			const newsMoreBox = document.querySelector(`div[data-news="${indexOfParent}"] .more_read`);
			const newsMoreBoxClose = document.querySelector(`div[data-news="${indexOfParent}"] .news__boxes__box__content__close`);
			const newsMoreBoxRead = document.querySelector(`div[data-news="${indexOfParent}"] .news__boxes__box__content__read_more`);
			this.moreBoxIndexSet.delete(parseFloat(indexOfParent))

			gsap.timeline({
				onComplete: () => {
					gsap.set(newsMoreBox, { clearProps: 'maxHeight,position,opacity,marginBottom' })
				}
			})
				.fromTo(newsMoreBox, { maxHeight: newsMoreBox.offsetHeight }, { duration: 0.4, opacity: 0, maxHeight: 0, marginBottom: 0 })
				.set(newsMoreBox, { position: 'absolute' })
				.to(newsMoreBoxClose, { duration: 0.4, autoAlpha: 0 }, '-=0.4')
				.set(newsMoreBoxClose, { display: 'none' })
				.set(newsMoreBoxRead, { display: 'block' })
				.to(newsMoreBoxRead, { duration: 0.4, autoAlpha: 1 }, '+=0.1')

		},
		lastNewsIndex() {
			let mqlC = window.matchMedia('(max-width: 1200px)');
			let indexNews = Number;

			if (mqlC.matches) {
				indexNews = Math.ceil((this.newsMoreBoxIndex + 1) / 2) * 2 - 1;

				if (this.newsArray.length - 1 < indexNews) {
					indexNews--
				}
			} else {
				indexNews = Math.ceil((this.newsMoreBoxIndex + 1) / 3) * 3 - 1;
				if (this.newsArray.length - 1 < indexNews) {
					const correctIndex = indexNews - (this.newsArray.length - 1);
					indexNews = indexNews - correctIndex;
				}
			}
			this.indexNews = indexNews;
		},
		async loadMoreNews() {
			this.newsOffset += 3;
			let url = window.location.href;

			try {
				const response = await axios.post(`${url}wp-json/av/v1/news`, {
					offset: this.newsOffset,
					count: this.numberpost
				})

				const data = response.data.data;

				if (data.news.length != 0) {
					data.news.forEach(el => {
						this.newsArray.push(el);
					})

					if (this.newsArrayMore == null) {
						this.newsArrayMore = data.news;
					} else {
						data.news.forEach(el => {
							this.newsArrayMore.push(el);
						})
					}
					this.newsLength += data.news.length;
					this.readMore = data.read_more;
				}

				this.checkCountNews();

			} catch (error) {
				throw new Error(error)
			}
		},
		checkCountNews() {
			if (this.allnewslength == this.newsArray.length) {
				this.$refs.moreButton.style.opacity = 0;
			}
		},
		appearBoxes(el) {
			gsap.fromTo(el, { duration: 0.3, opacity: 0 }, { opacity: 1 })
		},
		handleResize() {
			let mqlA = window.matchMedia('(max-width: 420px)');

			if (typeof this.newsMoreBoxIndex == 'number') {

				if (mqlA.matches) {
					this.moreBoxIndexSet.forEach(el => {
						const container = document.querySelector(`div[data-news="${el}"]`)
						const read_more = container.querySelector('.news__boxes__box__content__read_more')
						read_more.style.opacity = 0;
					})
				} else {
					gsap.set(this.newsMoreBoxDesktop, { clearProps: 'maxHeight' })
					this.checkMoreBoxPosition();

					this.moreBoxIndexSet.forEach(el => {
						const container = document.querySelector(`div[data-news="${el}"]`)
						const read_more = container.querySelector('.news__boxes__box__content__read_more')
						read_more.removeAttribute('style');
					})
				}
			}
		}
	}
}